export default class HeaderProductPage {
    // eslint-disable-next-line max-statements
    constructor(domElement) {
        if(!domElement) {
            throw new Error('domElement is undefined');
        }

        this.domElement = domElement;
        this.html = document.querySelector('html');
        this.triggerList = document.querySelectorAll('[data-header-product-pg-trigger]');
        this.domOverlay = document.querySelector('.header-product-pg__mobile__overlay');
        this.setActiveBind = this.setActive.bind(this);

        this.initListeners();
        this.initListenersMobile(this.triggerList, this.domOverlay);
        this.hoverOverItemsList();
        this.hoverOverProductList();
    }

    ACTIVE_TAB_TITLE = 'Onglet actif';

    BUTTON_BURGER_MENU = 'js-burger-menu';

    BUTTON_CLOSE_MENU = 'js-close-menu';

    OVERLAY_VISIBLE_CLASS_NAME = 'header-product-pg__mobile__overlay--visible';

    OVERLAY_HIDDEN_CLASS_NAME = 'header-product-pg__mobile__overlay--hidden';

    // eslint-disable-next-line class-methods-use-this
    titleAttributeSwitcher(domActive, domNextActive) {
        if(domActive !== null) {
            domActive.removeAttribute('title');
        }
        domNextActive.setAttribute('title', this.ACTIVE_TAB_TITLE);
    }

    setTabActive(domTarget) {
        // eslint-disable-next-line max-len
        const domCurrentActiveTab = this.domElement.querySelector(`[title="${this.ACTIVE_TAB_TITLE}"]`);

        if(domTarget === domCurrentActiveTab) {
            return;
        }

        this.titleAttributeSwitcher(domCurrentActiveTab, domTarget);
    }

    setActive(event) {
        this.setTabActive(event.currentTarget);
    }

    initListeners() {
        // eslint-disable-next-line max-len
        const domHeaderTabs = [...this.domElement.querySelectorAll('[data-header-tab]')];

        domHeaderTabs.forEach(domItem => {
            domItem.addEventListener('focus', this.setActiveBind);
        });
    }

    hoverOverItemsList() {
        this.listItems = document.querySelectorAll('.header-product-sp__navigation__item--text');
        this.listItems.forEach(item => {
            item.addEventListener('mouseover', () => {
                item.classList.add('header-product-sp__navigation__item--text--hovered');
                document.querySelectorAll('.header-product-pg__mobile__overlay__navigation-links')[0].classList.add('being-hovered');
            });

            item.addEventListener('mouseout', () => {
                item.classList.remove('header-product-sp__navigation__item--text--hovered');
                document.querySelectorAll('.header-product-pg__mobile__overlay__navigation-links')[0].classList.remove('being-hovered');
            });
        });
    }

    hoverOverProductList() {
        this.ProductListItems = document.querySelectorAll('.header-product-pg__navigation__item--link-label');
        this.ProductListItems.forEach(productItem => {
            productItem.addEventListener('mouseover', () => {
                productItem.classList.add('header-product-pg__navigation__item--link-label--hovered');
                document.querySelectorAll('.header-product-pg__mobile__overlay__navbar--primary')[0].classList.add('being-hovered-particular');
            });

            productItem.addEventListener('mouseout', () => {
                productItem.classList.remove('header-product-pg__navigation__item--link-label--hovered');
                document.querySelectorAll('.header-product-pg__mobile__overlay__navbar--primary')[0].classList.remove('being-hovered-particular');
            });
        });
    }

    initListenersMobile(triggerList, domOverlay) {
        triggerList.forEach(trigger => {
            trigger.addEventListener('click', event => {
                event.preventDefault();
                event.stopPropagation();

                const button = trigger.dataset.headerProductPgTrigger;

                if(button === this.BUTTON_BURGER_MENU) {
                    this.toggleOverflow(true);
                    this.toggleOverlay(true, domOverlay);
                }

                if(button === this.BUTTON_CLOSE_MENU) {
                    this.toggleOverflow(false);
                    this.toggleOverlay(false, domOverlay);
                }
            });
        });
    }

    toggleOverflow(needOverflowHidden) {
        const overflowHiddenClassName = 'ovh';
        if(needOverflowHidden) {
            this.html.classList.add(overflowHiddenClassName);
            document.body.classList.add(overflowHiddenClassName);
        } else {
            this.html.classList.remove(overflowHiddenClassName);
            document.body.classList.remove(overflowHiddenClassName);
        }
    }

    toggleOverlay(needOverlayVisible, domOverlay) {
        if(needOverlayVisible) {
            domOverlay.classList.remove(this.OVERLAY_HIDDEN_CLASS_NAME);
            domOverlay.classList.add(this.OVERLAY_VISIBLE_CLASS_NAME);
        } else {
            domOverlay.classList.remove(this.OVERLAY_VISIBLE_CLASS_NAME);
            domOverlay.classList.add(this.OVERLAY_HIDDEN_CLASS_NAME);
        }
    }
}
